import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
    static values = { id: String }

    connect() {
        const id = this.idValue
        const el = document.getElementById(id)
        if (el) {
            const instance = bootstrap.Modal.getInstance(el) || new bootstrap.Modal(el)
            instance.hide()
        }
        // safety: clean up any leftover backdrop/body class
        document.querySelectorAll(".modal-backdrop").forEach(b => b.remove())
        document.body.classList.remove("modal-open")
        this.element.remove() // self-cleanup
    }
}